import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ClaimProvider } from './state/ClaimContext';
import { LandingPage } from './routes/LandingPage';
import { IdentityPage } from './routes/IdentityPage';
import { PaymentPage } from './routes/PaymentPage';
import { ConfirmationPage } from './routes/ConfirmationPage';
import { RequestProviderPage } from './routes/RequestProviderPage';
import { CheckEmailPage } from './routes/CheckEmailPage';
import { ClaimLinkPage } from './routes/ClaimLinkPage';

/**
 * Claim portal — NO auth gate. Patients arrive anonymous and authenticate
 * via their identity + provider code + Stripe payment. Anonymous Firebase
 * Auth happens silently in the background for rate limiting + abuse detection.
 *
 * Routes:
 *   /                 → LandingPage    (enter provider code)
 *   /identity         → IdentityPage   (name, DOB → emails a link; Tess re-scan 3)
 *   /check-email      → CheckEmailPage (same message for everyone)
 *   /claim?t=…        → ClaimLinkPage  (opened from the email; T&Cs)
 *   /payment          → PaymentPage    (Stripe Elements; needs the link)
 *   /confirmation     → ConfirmationPage
 *
 * State (provider code + identity + intent client secret) lives in
 * ClaimContext so navigating back/forward doesn't lose the user. On a
 * hard refresh we restore from sessionStorage (cleared on confirmation).
 */
export function App() {
  return (
    <BrowserRouter>
      <ClaimProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/identity" element={<IdentityPage />} />
          <Route path="/check-email" element={<CheckEmailPage />} />
          <Route path="/claim" element={<ClaimLinkPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/request" element={<RequestProviderPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ClaimProvider>
    </BrowserRouter>
  );
}
